export class GetCatalogSetupResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "glue",
            "baseName": "glue",
            "type": "GlueFederatedSetup",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetCatalogSetupResponse.attributeTypeMap;
    }
    constructor() {
    }
}
